import { useState } from 'react';
import { Header, Chip } from '../../shared/components';
import { EmployeesTab } from './components/EmployeesTab';
import { ShiftRecordsTab } from './components/ShiftRecordsTab';
import { SummaryTab } from './components/SummaryTab';
import { TurnoGeoOvertimeTab } from './components/TurnoGeoOvertimeTab';

/**
 * Modulo Horas Extra - reemplaza al archivo "CALCULO TIEMPO EXTRA-v2.xlsm".
 * Tres pestañas, equivalentes a las tres hojas del Excel:
 *  - Empleados      <- datos maestros de la hoja RESUMEN
 *  - Registro Diario <- hoja EXTRA (TablaHoras)
 *  - Resumen        <- hoja RESUMEN, calculada en vivo (sin boton "Calcular")
 */
export function OvertimePage() {
  const [tab, setTab] = useState<'employees' | 'records' | 'summary' | 'turnogeo'>('summary');

  return (
    <div>
      <Header title="Horas Extra" subtitle="Liquidación de horas extra, recargos y festivos" />
      <div className="space-y-6 p-4">
        <div className="flex flex-wrap gap-2">
          <Chip label="Resumen" active={tab === 'summary'} onClick={() => setTab('summary')} />
          <Chip label="Registro diario" active={tab === 'records'} onClick={() => setTab('records')} />
          <Chip label="Horas de TurnoGeo" active={tab === 'turnogeo'} onClick={() => setTab('turnogeo')} />
          <Chip label="Empleados" active={tab === 'employees'} onClick={() => setTab('employees')} />
        </div>
        {tab === 'summary' && <SummaryTab />}
        {tab === 'records' && <ShiftRecordsTab />}
        {tab === 'employees' && <EmployeesTab />}
        {tab === 'turnogeo' && <TurnoGeoOvertimeTab />}
      </div>
    </div>
  );
}
